var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"has-tooltip"},[_c('img',{staticClass:"w-6 h-6",attrs:{"src":_vm.src}}),_c('span',{staticClass:"tooltip"},[_vm._v(_vm._s(_vm.status.verbose))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }